import { render, staticRenderFns } from "./wxErrorLog.vue?vue&type=template&id=fa59c814"
import script from "./wxErrorLog.vue?vue&type=script&lang=js"
export * from "./wxErrorLog.vue?vue&type=script&lang=js"
import style0 from "./wxErrorLog.vue?vue&type=style&index=0&id=fa59c814&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports